.report-analytics-page {
    height: 100%;
}
